import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { MdOutlineSouth, MdOutlineNorth } from 'react-icons/md';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';

function SortOptions({ onSort, isOnward, prevSortParam, isOneWay }) {
  const intl = useIntl();
  const [sortBy, setSortBy] = useState('price');
  const [sortOrder, setSortOrder] = useState('asc');

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const handleSort = (param) => {
    let order = '';
    if (prevSortParam === param) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      order = 'asc';
    }
    setSortBy(param);
    setSortOrder(order);
    onSort(param, order, isOnward);
  };

  const getVariant = (param) => {
    const isActive = sortBy === param;

    if (isOneWay) {
      return isActive ? 'primary' : 'sortopt';
    }

    return isActive ? 'primary' : 'grey';
  };

  return (
    <div className="fs-14 d-flex gap-3 align-content-center justify-content-around pt-1 pe-5">
      <div className="sort-heading">
        <FormattedMessage id="sort_by_header" />
      </div>
      <div className="d-flex justify-content-center align-items-center">
        {sortBy === 'airline' && sortOrder === 'asc' && <MdOutlineSouth />}
        {sortBy === 'airline' && sortOrder === 'desc' && <MdOutlineNorth />}
        <AppLink
          onClick={() => handleSort('airline')}
          linkText={formattedMessage('airline')}
          className="ps-1 sort-option"
          variant={getVariant('airline')}
        />
      </div>
      <div className="d-flex justify-content-center align-items-center">
        {sortBy === 'departure' && sortOrder === 'asc' && <MdOutlineSouth />}
        {sortBy === 'departure' && sortOrder === 'desc' && <MdOutlineNorth />}
        <AppLink
          onClick={() => handleSort('departure')}
          linkText={formattedMessage('departure')}
          className="ps-1 sort-option"
          variant={getVariant('departure')}
        />
      </div>
      {/* <div className="d-flex justify-content-center align-items-center">
        {sortBy === 'duration' && sortOrder === 'asc' && <MdOutlineSouth />}
        {sortBy === 'duration' && sortOrder === 'desc' && <MdOutlineNorth />}
        <AppLink
          onClick={() => handleSort('duration')}
          linkText={formattedMessage('duration')}
          className="ps-1 sort-option"
          variant={sortBy === 'duration' ? 'primary' : 'grey'}
        />
      </div> */}
      <div className="d-flex justify-content-center align-items-center">
        {sortBy === 'arrival' && sortOrder === 'asc' && <MdOutlineSouth />}
        {sortBy === 'arrival' && sortOrder === 'desc' && <MdOutlineNorth />}
        <AppLink
          onClick={() => handleSort('arrival')}
          linkText={formattedMessage('arrival')}
          className="ps-1 sort-option"
          variant={getVariant('arrival')}
        />
      </div>
      <div className="d-flex justify-content-center align-items-center">
        {sortBy === 'price' && sortOrder === 'asc' && <MdOutlineSouth />}
        {sortBy === 'price' && sortOrder === 'desc' && <MdOutlineNorth />}
        <AppLink
          onClick={() => handleSort('price')}
          linkText={formattedMessage('price')}
          className="ps-1 sort-option"
          variant={getVariant('price')}
        />
      </div>
    </div>
  );
}

SortOptions.propTypes = {
  isOnward: PropTypes.bool.isRequired,
  onSort: PropTypes.func.isRequired,
  prevSortParam: PropTypes.string.isRequired,
  isOneWay: PropTypes.bool,
};

SortOptions.defaultProps = {
  isOneWay: false, // default required by ESLint
};

export default SortOptions;
